import React from 'react';
import clsx from 'clsx';

interface Props {
	text: string;
	linkColor?: string;
	fontFamily?: string;
	additionalClass?: string;
}

export const LinkComponent = ({ text, linkColor, fontFamily, additionalClass }: Props): React.ReactElement => {

	return (
		<a
			className={clsx(additionalClass)}
			href="#"
			target="_blank"
			style={{ color: `${linkColor}`, fontFamily: `${fontFamily}` }}
			rel="noreferrer"
		>
			{text}{' '}
		</a>
	);
};
